module.exports = __webpack_public_path__ + "static/img/fraud.5963b5a4.png";